import { Outlet } from 'react-router-dom';

import { useParkingContext } from '@features/ownedParkingManage/contexts/ParkingContext';
import { UnavailabilitiesProvider } from '@features/ownedParkingManage/contexts/UnavailabilitiesContext';

export default function UnavailabilitiesDataLayout() {
  const parking = useParkingContext();

  return (
    <UnavailabilitiesProvider parkingId={parking.id}>
      <Outlet />
    </UnavailabilitiesProvider>
  );
}
